import React, { Component } from 'react';


class ProductTypes extends Component {

    state = {
        types: [
            React.Component.prototype.$intl.get('产品'), 
            React.Component.prototype.$intl.get('德国运输'), 
            React.Component.prototype.$intl.get('包装'), 
            React.Component.prototype.$intl.get('折扣'), 
            React.Component.prototype.$intl.get('国际运输'), 
            React.Component.prototype.$intl.get('金属附加费'), 
            React.Component.prototype.$intl.get('其他附加费用'),
            React.Component.prototype.$intl.get('国际转账手续费'),
            React.Component.prototype.$intl.get('供货商折扣'),
            React.Component.prototype.$intl.get('软件产品/证书'),
            React.Component.prototype.$intl.get('运单服务费'),
        ],
    }

    render() {
        const { type } = this.props;

        return (
            <span>{ type === 0 ? null : this.state.types[type] }</span>
        );
    }
  
}

export default ProductTypes;
